import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { selectHistoryContent, selectPureCorrection, selectQuery, selectSearchResultsPageUrl } from "../../../../../store/slices/search/selectors";
import { useAppSelector } from "../../../../../store/hooks";
import { getSearchPageUrl } from "../../../utils/getSearchPageUrl";
import { EDIGI, methodsDigi } from "../../../../../../../utils/analytics";
import { getIsWebview } from "../../../utils/getIsWebView";
import { convertHistoryToCell, deleteHistoryItem, prepareHistorySearch } from "../../../utils/storage";
export var useHistory = function useHistory() {
  var query = useAppSelector(selectQuery);
  var correction = useAppSelector(selectPureCorrection);
  var _useAppSelector = useAppSelector(selectHistoryContent),
    cookieName = _useAppSelector.cookieName,
    daysToExpire = _useAppSelector.daysToExpire;
  var searchUrl = useAppSelector(selectSearchResultsPageUrl);
  var isWebView = getIsWebview();
  var _useState = useState(isWebView ? [] : prepareHistorySearch({
      cookieName: cookieName,
      query: query
    })),
    _useState2 = _slicedToArray(_useState, 2),
    historyList = _useState2[0],
    setHistoryList = _useState2[1];
  useEffect(function () {
    setHistoryList(prepareHistorySearch({
      cookieName: cookieName,
      query: query
    }));
  }, [cookieName, query]);
  var onClear = function onClear(value) {
    deleteHistoryItem({
      cookieName: cookieName,
      daysToExpire: daysToExpire,
      query: value
    });
    setHistoryList(historyList.filter(function (item) {
      return item !== value;
    }));
  };
  var onClick = function onClick(value) {
    var _window;
    methodsDigi.sendClickEvent({
      query: query,
      correction: correction,
      item: value,
      type: EDIGI.history
    });
    (_window = window) === null || _window === void 0 ? void 0 : _window.location.assign(getSearchPageUrl({
      url: searchUrl,
      query: value
    }));
  };
  return {
    list: convertHistoryToCell(historyList),
    onClear: onClear,
    onClick: onClick
  };
};